import { memberMobx, themeMobx } from '@mobxStore'
import mktController from 'controllers/mktController'
import { store, getParams, addParams } from '@dt/fe-utils'
import { getPlatform } from '@utils'
import { pick, toInteger } from '@dt/fe-utils/dist/lodash'
import env from 'env'
import ThirdAuthAPI from '@api/thirdAuth.api'
import { WorkWeixinCanOpenBrands } from '@common/utils/hack'

function replace (state: string) {
  history.pushState({}, '', state + location.search)
}

/**
 * jwt token 解析
 * @param str
 * @returns
 */
function b64_to_utf8 (str: string) {
  return decodeURIComponent(escape(window.atob(str)))
}
/**
 * 验证是否可以公众号授权
 * @returns {0 | 1} 0 可以授权 | 1 不可授权
 */
async function checkCanAuthWechat () {
  try {
    const res = await ThirdAuthAPI.getMpStatusByBrandId()
    return res.data || 0
  } catch (error) {
  }
  return 0
}

/**
 * 授权处理
 */
export default async function (memberData?: any) {
  const { BRANDID } = Config
  const { isWeixin, isWeixinMiniProgram, isWorkWeixin, isAlipay } = getPlatform()
  const matchs = document.location.pathname.match(/^\/([^/]*)\/?/)
  const pathState = matchs ? matchs[1] : ''
  // 国内非微信环境，进入错误处理，测试下不进行拦截
  if (((isWeixin && !isWorkWeixin) || isAlipay) && bo === 'cn') {
    const urlPath = `${location.origin}${location.pathname}`
    const urlParams = getParams({
      url: window.location.search
    })
    const _params = pick(urlParams, ['p', 'lat', 'lng', 'et', 'tt', 'ot', 'appId', 'city', 'bt', 'inMiniApp', 'wechatAuth', 'gopenId', 'buyTogetherId', 'shareInfo', 'addMyAppTime', 'queueId', 'isNewMember', 'webviewLoaded', 'miniVersion', 'forceToMenu', 'posOrdersId', 'ordersId', 'cardNo', 'cardPin', 'fromNavigateTo'])
    const query = new URLSearchParams(location.search)
    const locNeedOpenId = localStorage.getItem(`ls.needOpenId.flag.${BRANDID}`)
    const locGOpenId = locNeedOpenId ? localStorage.getItem(`ls.needOpenId.gOpenId.${BRANDID}`) : null
    let jumpCount = query.get('jumpCount') || 0
    let authstep = query.get('authstep') // 授权步骤 1 gopenId授权, 2-openId授权
    let scope = query.get('scope') // snsapi_userinfo || snsapi_base
    let wechatAuth = query.get('wechatAuth') || locNeedOpenId
    let gOpenId = query.get('gopenId') || query.get('gopenid') || locGOpenId
    // 聚合支付不需要继续跳转
    if ((gOpenId || memberData.gOpenId) && location.pathname.indexOf('/mergeqrv2') > -1) {
      return 'mergeqrv2'
    }
    // memberData?.member?.openId && (memberData.member.openId = '' as any)
    console.log('第三方网页授权______', memberData)
    if (BRANDID && (!memberData || !memberData?.member || (!authstep && !memberData?.member?.gOpenId) || (authstep === '1' && !memberData?.member?.gOpenId) || (authstep === '2' && memberData?.member?.hasNullWechatOpenId) || (memberData?.member?.gOpenId && memberData?.member?.hasNullWechatOpenId))) {
      if (memberData?.member?.gOpenId && memberData?.member?.hasNullWechatOpenId) {
        // 不可授权公众号
        const notAuthWechat = await checkCanAuthWechat() || 0
        if (notAuthWechat) return true
      }
      let token = query.get('token') // 授权token
      let authflag = false
      let memberInfo: IMemberInfo
      console.log('auth_token:', token)
      if (token) {
        let memberString: any
        let decodeFlag: boolean = true
        try {
          memberString = JSON.parse(b64_to_utf8(token.split('.')[1]))
          console.log('memberString', memberString)
        } catch (error) {
          decodeFlag = false
        }
        if (isWeixin) {
          if (isWeixinMiniProgram && !authstep) {
            memberInfo = await memberMobx.login('token', { token })
          } else {
            if (isWeixinMiniProgram) {
              if ((memberString && memberString.openId !== undefined) || !decodeFlag) {
                memberInfo = await memberMobx.login('wechatPage', { token, gOpenId })
              } else {
                memberInfo = {
                  gAppId: memberString?.gAppId,
                  gOpenId: memberString?.gOpenId
                } as IMemberInfo
                localStorage.removeItem(`ls.token${window.appEnv}.${Config.BRANDID}`)
              }
            } else {
              memberInfo = await memberMobx.login('wechatPage', { token, gOpenId })
            }
          }
        } else if (isAlipay) {
          memberInfo = await memberMobx.login('token', { token })
        }
        if (memberInfo) {
          if (authstep === '2' || (memberInfo.openId && memberInfo.gOpenId)) {
            memberMobx.setThirdAuthInfo({
              openId: memberInfo.openId,
              gOpenId: memberInfo.gOpenId,
            })
            await mktController.loginEnd()
            window.history.replaceState(
              window.history.state,
              '',
              addParams({
                url: location.pathname + themeMobx.urlSearch,
                params: _params
              })
            )
            return true
          }
        } else {
          token = null
          return true
        }
      }
      if (!token) {
        if (memberData) {
          if (memberData?.member?.gOpenId) {
            authflag = true
          }
        }
      }
      console.log('authflag', authflag, wechatAuth)
      // 强制获取gopenid
      if (isWeixin && isWeixinMiniProgram && !wechatAuth && Number(jumpCount) < 3 && memberData?.member && !memberData?.member?.gOpenId) {
        authflag = false
        authstep = undefined
      }
      // 强制获取openid
      if (isWeixin && isWeixinMiniProgram && !wechatAuth && Number(jumpCount) < 3 && memberData?.member && memberData?.member?.gOpenId && !memberData?.member?.openId) {
        authflag = false
      }
      if (isWeixin && wechatAuth && gOpenId) {
        authstep = '1'
      }
      console.log('authflag', authflag)
      if (!authflag) {
        if (authstep === '2') {
          return false
        } else if (!authstep) {
          if (isAlipay) {
            let alipayLoginUrl: string = ENV.MEMBER +
              '/login/alipayAuth/v2?bu=' +
              encodeURIComponent(encodeURIComponent(window.location.href))
            if (Config.shareInfo) {
              alipayLoginUrl += `&invitation=${Config.shareInfo}`
            }
            if (Config.posLoginInfo) {
              const obj: any = JSON.parse(decodeURIComponent(Config.posLoginInfo))
              const deviceInfo = {
                deviceId: obj.storeDeviceId,
                timestamp: obj.time
              }
              alipayLoginUrl += `&deviceInfo=${encodeURIComponent(JSON.stringify(deviceInfo))}`
            }
            let authurl = '//' +
              ENV.GWP +
              '/api/ali/user/auth?wpdomain=' +
              ENV.GWP +
              '&bu=' +
              encodeURIComponent(alipayLoginUrl) +
              '&brandid=' +
              BRANDID
            console.log('支付宝_授权地址:', authurl)
            // return
            location.replace(authurl)
          } else {
            // const authurl = window.location.href + '&authstep=1' +
            //   '&jumpCount=' + (Number(jumpCount) + 1)
            const authurl = addParams({
              url: urlPath,
              params: {
                ...urlParams,
                authstep: 1,
                jumpCount: Number(jumpCount) + 1
              }
            })
            console.log('微信_授权地址1', authurl)
            location.replace(
              `${ENV.GLOBAL_ID}/wechat/gauth?redirect_url=${encodeURIComponent(
                authurl
              )}`
            )
          }
        } else if (authstep === '1') {
          console.log('memberInfo', memberInfo)
          window.history.replaceState(
            window.history.state,
            '',
            addParams({
              url: location.pathname + themeMobx.urlSearch,
              params: _params
            })
          )
          if (!scope) {
            scope = 'snsapi_base'
          }
          const authurl =
            ENV.GWPT +
            '/wx/v4/auth/wechat?brandId=' +
            BRANDID +
            '&gappid=' + memberInfo?.gAppId +
            '&gopenid=' + memberInfo?.gOpenId +
            '&scope=' + scope +
            '&checkNickName=true&bu=' +
            encodeURIComponent(window.location.href + '&authstep=2')
          console.log('微信_授权地址2', authurl)
          location.replace(authurl)
        }
        return false
      }
    }
  }
  if (localStorage.getItem(`ls.miniOpenLink.${BRANDID}`) && process.env.NODE_ENV !== 'development' && !localStorage.getItem('isDebug') && env.env !== 'test') {
    replace('/jumpWx')
    return 'jumpWx'
  }
  const canEnterKeys: any[] = ['bill', 'my', 'login', 'redeem', 'iGc', 'memberCard', 'iRecord', 'iCoupon', 'groupBuy', 'myInvoice', 'luckyDraw', 'pointCard', 'giftCard', 'activity', 'billBuyTogether', 'eval', 'jumpWx']
  if ((!isWeixin || isWorkWeixin) && !isAlipay && bo === 'cn' && process.env.NODE_ENV !== 'development' && !window?.cordova && !canEnterKeys.includes(pathState) && !store.get('cn.openbrower') && env.env !== 'test') {
    if (!WorkWeixinCanOpenBrands.includes(toInteger(BRANDID))) {
      replace('/notWeixin')
      return 'notWeixin'
    }
  }
  return true
}
